import React, { CSSProperties, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { SelectValue } from 'antd/es/select'
import { NameDto } from 'api/Common/Types'
import { Select } from 'components/Select'

interface ModalProps {
  onChange: (version: NameDto<string | number>) => void
  initialValue?: string
}

interface ModalFilterProps {
  placeholder?: string
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  style?: CSSProperties
  Modal: React.FC<ModalProps>
}

export const ModalFilter: React.FC<ModalFilterProps> = ({
  filter,
  onFilterChange,
  placeholder,
  Modal: FilterModal,
}) => {
  const [selectedData, setSelectedData] = useState<SelectValue>([])
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const onChange = (value: NameDto<string | number>) => {
    setSelectedData([{ label: value.name, value: value.id }])
    onFilterChange.call(undefined, {
      nextFilter: { ...filter, value: value.id },
    })
    setModalIsOpen(false)
  }

  return (
    <>
      <Dialog open={modalIsOpen} onOpenChange={setModalIsOpen}>
        <DialogContent size='3xl'>
          <DialogHeader>
            <DialogTitle>{placeholder ?? 'Select value'}</DialogTitle>
          </DialogHeader>
          <FilterModal initialValue={filter.value} onChange={onChange} />
        </DialogContent>
      </Dialog>

      <Select
        labelInValue={true}
        placeholder={placeholder}
        fullWidth
        open={false}
        value={selectedData}
        onFocus={() => setModalIsOpen(true)}
      />
    </>
  )
}
